import { useState } from "react";

function MailIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m2 6 10 7L22 6" />
    </svg>
  );
}
function LockIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );
}
function UserIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}
function KeyIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="7.5" cy="15.5" r="4.5" />
      <path d="m10.7 12.3 8.3-8.3M17 6l2 2M14 9l2 2" />
    </svg>
  );
}
function EyeIcon({ off }: { off?: boolean }) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
      {off && <line x1="3" y1="3" x2="21" y2="21" />}
    </svg>
  );
}

const ICONS = { mail: MailIcon, lock: LockIcon, user: UserIcon, key: KeyIcon };

export default function AuthField({
  icon,
  type,
  value,
  onChange,
  placeholder,
  required,
  minLength,
  maxLength,
  invalid,
  name,
  autoComplete,
  inputMode,
  autoFocus,
}: {
  icon: keyof typeof ICONS;
  type: "text" | "email" | "password";
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  invalid?: boolean;
  name?: string;
  autoComplete?: string;
  inputMode?: "text" | "numeric";
  autoFocus?: boolean;
}) {
  const [show, setShow] = useState(false);
  const [focused, setFocused] = useState(false);
  const Icon = ICONS[icon];
  const isPassword = type === "password";
  const inputType = isPassword && show ? "text" : type;

  const borderColor = invalid
    ? "rgba(248,113,113,0.7)"
    : focused
    ? "var(--brand)"
    : "var(--border-strong)";

  return (
    <div className="relative">
      <span
        className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2"
        style={{ color: "var(--text-muted)" }}
      >
        <Icon />
      </span>
      <input
        type={inputType}
        required={required}
        minLength={minLength}
        maxLength={maxLength}
        name={name}
        autoComplete={autoComplete}
        inputMode={inputMode}
        autoFocus={autoFocus}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        className={`w-full rounded-[12px] py-2.5 pl-10 ${isPassword ? "pr-10" : "pr-3"} outline-none transition`}
        style={{
          background: "var(--bg-elev)",
          border: `1px solid ${borderColor}`,
          color: "var(--text)",
          boxShadow: focused ? "0 0 0 3px var(--brand-ring)" : undefined,
        }}
      />
      {isPassword && (
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          className="absolute right-3 top-1/2 -translate-y-1/2 transition"
          style={{ color: "var(--text-muted)" }}
          aria-label={show ? "Hide password" : "Show password"}
        >
          <EyeIcon off={show} />
        </button>
      )}
    </div>
  );
}
